export type PageRequest = {
  offset: number;
  size: number;
  sortBy: string;
  sortDirection: 'asc' | 'desc';
};

export type LoyaltyCategory = {
  id?: number;
  name: string;
  minSalesMonth: number;
  multiplier: number;
  /** Бонусные баллы за достижение/повышение категории */
  upgradeBonus: number;
};

export type LoyaltyCategoryForm = {
  name: string;
  minSalesMonth: string;
  multiplier: string;
  upgradeBonus: string;
};

export type AccrualSettings = {
  id?: number;
  /** Бонус за первую продажу месяца включён */
  enabled: boolean;
  firstSaleMonthPoints: number;
  /** Общий выключатель мотивации: первая продажа, миссии, категории, возврат */
  motivationEnabled?: boolean;
  /** Бонус за возврат в программу («спящие» продавцы) */
  sleepBonusEnabled?: boolean;
  sleepBonusPoints?: number;
  /** Сколько успешных продаж в месяце возврата нужно для бонуса */
  sleepBonusMinSales?: number;
  /** Сколько полных месяцев без продаж считается простоем */
  sleepBonusIdleMonths?: number;
};

export type AccrualSettingsForm = {
  enabled: boolean;
  firstSaleMonthPoints: string;
  motivationEnabled: boolean;
  sleepBonusEnabled: boolean;
  sleepBonusPoints: string;
  sleepBonusMinSales: string;
  sleepBonusIdleMonths: string;
};

/** Тип миссии по Postman: SALES (цель — число продаж) */
export type MissionType = 'SALES' | string;

export type Mission = {
  id?: number;
  /** Present on category↔mission link rows (id then is the link row id). */
  missionId?: number;
  /** Link-row display name when top-level `name` is absent. */
  missionName?: string;
  /** Nested mission payload on some link-row DTOs. */
  mission?: {
    id?: number;
    name?: string;
    active?: boolean;
    targetValue?: number;
    reward?: number;
    type?: MissionType;
  };
  name: string;
  description: string;
  type: MissionType;
  targetValue: number;
  reward: number;
  active: boolean;
};

/** Max length for category / mission names (UI + validation). */
export const NAME_MAX_LENGTH = 56;

export type MissionForm = {
  name: string;
  description: string;
  type: string;
  targetValue: string;
  reward: string;
  active: boolean;
};

export const defaultPageRequest: PageRequest = {
  offset: 0,
  size: 100,
  sortBy: 'id',
  sortDirection: 'asc',
};

export const missionTypeOptions = [
  { key: 'SALES', value: 'SALES', text: 'Продажи (SALES)' },
];
